/** @jsxImportSource @emotion/react */
import React, { useContext, useState } from "react";
import { LocaleContext } from "../../context/LocaleContext";
import { useCopyToClipboard } from "../../helpers/useCopyToClipboard";
import Button from "../Button";
import ModalConfirmGift from "../ModalConfirmGift";
import { stySectionTitle } from "../styles";
import {
  txtConfirmationButton,
  txtCopied,
  txtCopyButton,
  txtGiveDescription,
  txtGiveDescriptionX,
  txtGiveNote,
  txtGiveTitle,
} from "./locales";
import { styGiveCard } from "./styles";
import { ACCOUNT_INFO } from "../../constants";
import { useLocation } from "react-router-dom";

const Give = () => {
  const { lang } = useContext(LocaleContext);
  const location = useLocation();

  const isGuestRoute = location.pathname.includes("/guest/");
  const [value, copy] = useCopyToClipboard();
  const [isOpemModalConfirm, setIsOpenModalCOnfirm] = useState(false);

  return (
    <section>
      <div css={stySectionTitle}>
        <h1>{txtGiveTitle[lang]}</h1>
      </div>
      <p>
        {isGuestRoute ? txtGiveDescription[lang] : txtGiveDescriptionX[lang]}
      </p>
      {isGuestRoute && (
        <>
          <div>
            <div>
              {ACCOUNT_INFO.map((item, index) => (
                <div key={index} css={styGiveCard}>
                  <h2 className="bank-name">{item.bank}</h2>
                  <p className="bank-number">{item.number}</p>
                  <p className="bank-owner">a/n {item.name}</p>
                  <Button onClick={() => copy(item.number)}>
                    {value === item.number
                      ? txtCopied[lang]
                      : txtCopyButton[lang]}
                  </Button>
                </div>
              ))}
            </div>
            <p>{txtGiveNote[lang]}</p>
            <Button onClick={() => setIsOpenModalCOnfirm(true)}>
              {txtConfirmationButton[lang]}
            </Button>
          </div>
          <ModalConfirmGift
            isOpen={isOpemModalConfirm}
            onClose={() => setIsOpenModalCOnfirm(false)}
            lang={lang}
          />
        </>
      )}
    </section>
  );
};

export default Give;
